import { render } from "./ExperienceHub.vue?vue&type=template&id=b40bbd36"
import script from "./ExperienceHub.vue?vue&type=script&lang=js"
export * from "./ExperienceHub.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/web-ae-pharma/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__